import { remove, sortBy } from "lodash";

interface Category {
    id: number;
    name: string;
    type: string;
}

export class FilterCategoryController {
    public static $inject: string[] = [
        "$element",
        "$scope",
        "categoryService"
    ];

    public allCategories;
    public category: string; // Binded
    public field: string; // Binded
    public searchTerm: string;
    public selectedCategories;

    constructor(
        private $element: JQLite,
        private $scope: ng.IScope,
        private categoryService
    ) {}

    public $onInit() {
        this.allCategories = this.getAllCategories();
        this.selectedCategories = this.getSelectedCategories(this.field, this.category);

        this.$scope.$watch(
            () => this.selectedCategories,
            selectedCategories => {
                this.field = "";
                this.category = "";
                selectedCategories.forEach(category => this.insertSelected(category));
            });

        this.$scope.$watchCollection(
            () => [this.field, this.category],
            (current, previous) => {
                if (angular.equals(current, previous)) {
                    return ;
                }

                // Reset
                if (!current[0] && !current[1]) {
                    this.selectedCategories = [];
                }
            }
        );

        this.$element.find("input").on("keydown", ev => {
            ev.stopPropagation();
        });
    }

    public clearSearchTerm() {
        this.searchTerm = "";
    }

    public insertSelected(selected) {
        if (selected.type === "domain") {
            const domain = this.field ? this.field.split(",") : [];

            domain.push(selected.id);
            this.field = domain.join();
        } else {
            const specialty = this.category ? this.category.split(",") : [];

            specialty.push(selected.id);
            this.category = specialty.join();
        }
    }

    public removeSelected(selected) {
        if (selected.type === "domain") {
            let domain = this.field ? this.field.split(",") : [];

            domain = domain.filter(domainId => {
                return (domainId !== selected.id);
            });
            this.field = domain.length ? domain.join() : null;
        } else {
            let specialty = this.category ? this.category.split(",") : [];

            specialty = specialty.filter(specialtyId => {
                return (specialtyId !== selected.id.toString());
            });
            this.category = specialty.length ? specialty.join() : null;
        }

        remove(
            this.selectedCategories,
            (selectedCategory: any) => selectedCategory.id === selected.id
        );
    }

    private getAllCategories() {
        const domains = this.categoryService.getFields();
        let specialties = angular.copy(this.categoryService.getCategories());
        const items = [];

        domains.forEach(domain => {
            const domainObj: Category = {
                id: domain.key,
                name: domain.label,
                type: "domain"
            };
            items.push(domainObj);
        });

        specialties = sortBy(specialties, ["name"]);

        specialties.forEach(specialty => {
            const specialtyObj: Category = {
                id: specialty.id,
                name: specialty.name,
                type: "specialty"
            };
            items.push(specialtyObj);
        });

        return items;
    }

    private getSelectedCategories(field, category) {
        const items = [];
        const fields = field ? field.split(",") : [];
        const categories = category ? category.split(",") : [];
        const params = fields.concat(categories);

        params.forEach(param => {
            this.allCategories.forEach(item => {
                if (param.toString() === item.id.toString()) {
                    items.push(item);
                }
            });
        });

        return items;
    }
}
